/*portugieser */
export function registerKendoTheme () {
kendo.dataviz.ui.registerTheme('customInsa', 
{   
    "chart": {
        "title": {
            "color": "#686868"
        },
        "legend": {
            "labels": {
                "color": "#686868"
            }
        },
        "chartArea": {
            "background": "#ffffff"
        },
        "seriesDefaults": {
            "labels": {
                "color": "#686868"
            },
       "pie": {
         "overlay": {
             "gradient": "none"
         }
     },
     
     "donut": {
         "overlay": {
             "gradient": "none"
         }
     },
     "column": {
         "overlay": {
             "gradient": "none"
         }
     }
        },
        "axisDefaults": {
            "line": {
                "color": "#9e9e9e"
            },
            "labels": {
                "color": "#686868"
            },
            "minorGridLines": {
                "color": "#e7e7e7"
            },
            "majorGridLines": {
                "color": "#dadada"
            },
            "title": {
                "color": "#686868"
            }
        },
        "seriesColors": [
            "#00dcfa",
            "#00b4c8",
            "#008ca0",
            "#005f69",
            "#004147",
            "#6C7071",
            "#555859",
            "#3A3D3D",
            "#202121"
        ]
    },
    "gauge": {
        "pointer": {
            "color": "#227591"
        },
        "scale": {
            "rangePlaceholderColor": "#e7e7e7",
            "labels": {
                "color": "#686868"
            },
            "minorTicks": {
                "color": "#aaaaaa"
            },
            "majorTicks": {
                "color": "#888888"
            },
            "line": {
                "color": "#9e9e9e"
            }
        }
    }
})};



// WEBPACK FOOTER //
// ./insa-css/insa-clients/Insa/insa-kendo-css/kendo.custom.dataviz.ts